// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"66":"75b2c669","245":"5c22aa4f","334":"0dee90eb","380":"f76f3553","427":"0237880d","565":"19505519","608":"0c4c20cd","683":"165c55af","875":"92959d0e"}[chunkId] + ".chunk.css";
};